import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface GetGiftCardByIdResponse {
  amount: number
  apartment: string
  buildingId: number
  category: string
  description: string
  expirationDate: number | null
  id: number
  recipientEmail: string
  recipientName: string
  recipientPhone: number | null
  redeemDate: number | null
  runaItemId: string | null
  runaOrderId: string | null
  runaProductId: string | null
  sendDate: number | null
  senderFullName: string | null
  source: string
  status: string
  type: string
}

const getGiftCardById = async ({ id, signal }: { id?: number; signal?: AbortSignal }) => {
  const response = await authAPI.get<GetGiftCardByIdResponse>(`/reward/${id}`, {
    signal,
  })

  return response.data
}

export const BASE_GET_GIFTCARD_BY_ID_QUERY_KEY = 'useGetGiftcardById'
export const getGiftcardByIdQueryKey = (id?: number) =>
  [BASE_GET_GIFTCARD_BY_ID_QUERY_KEY, id] as const

export const useGetGiftcardById = (
  id?: number,
  options?: Omit<
    UseQueryOptions<
      GetGiftCardByIdResponse,
      Error,
      GetGiftCardByIdResponse,
      ReturnType<typeof getGiftcardByIdQueryKey>
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery<
    GetGiftCardByIdResponse,
    Error,
    GetGiftCardByIdResponse,
    ReturnType<typeof getGiftcardByIdQueryKey>
  >({
    enabled: !!id,
    queryFn: ({ signal }) => getGiftCardById({ id, signal }),
    queryKey: getGiftcardByIdQueryKey(id),
    ...options,
  })
}
